import React from 'react';
import clsx from 'clsx';
import styles from './PrintAppointmentGrooming.module.scss';
import { PrintBookingDetailAppointmentViewModel } from '../utils/PrintBookingDetailViewModel';

type Props = {
    appointment: PrintBookingDetailAppointmentViewModel;
    dateLabel: string;
    className?: string;
    showDivider?: boolean;
};

export const PrintAppointmentGrooming: React.FC<Props> = ({
    appointment,
    dateLabel,
    className,
    showDivider = true
}) => {
    const time = appointment.timeLabel ?? '';
    const service = appointment.serviceName ?? '';
    const staff = appointment.staffName ?? '';

    return (
        <div className={clsx(styles.root, className, { [styles.withDivider]: showDivider })}>
            <span className={styles.dateLabel}>{dateLabel}</span>
            <div className={styles.serviceLine}>
                <div className={styles.time}>{time}</div>

                <div className={styles.line}>
                    <span className={styles.service}>{service}</span>
                    {!!staff && (
                        <>
                            <span className={styles.staffLabel}>STAFF</span>
                            <span className={styles.staffName}>{staff}</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PrintAppointmentGrooming;
